export default __webpack_public_path__ + "static/header-b8982f2b331bb28b5cae1807bb8515ef.svg";